










































import toFloat from '@/lib/toFloat.ts';
import dayjs from 'dayjs';
import {Component, Vue} from 'vue-property-decorator';
import {Message, MessageBox} from 'element-ui';

@Component
export default class Details extends Vue {
  public id = Number(this.$route.query.id);
  public currentDay = {};

  public toBack() {
    this.$router.back();
  }

  public beforeMount() {
    this.$store.commit('fetchTags');
    this.$store.commit('fetchRecord');

    const currentDay = this.$store.state.tallyRecord.filter((item: RecordItem) => {
      return item.id === this.id;
    })[0];
    if (this.id && currentDay) {
      if (currentDay.type === 'pay') {
        currentDay.parseType = '支出';
      } else if (currentDay.type === 'earn') {
        currentDay.parseType = '收入';
      }
      const date = dayjs(currentDay.date).format('YYYY-MM-DD').split('-');
      date[0] = date[0] + '年';
      date[1] = date[1] + '月';
      date[2] = date[2] + '日';
      currentDay.parseDate = date.toString().replace(/,/g, '');
      this.currentDay = currentDay;
    } else {
      return this.$message({
        message: '请确认数据是否存在',
        type: 'warning',
        duration: 1000,
        offset: 200,
      });
    }
  }

  public editRecord() {
    this.$router.push(`/editRecord?id=${this.id}`);
  }

  public deleteRecord() {


    this.$confirm('永久删除该记录?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      if (this.id) {
        this.$store.commit('deleteRecord', this.id);
        setTimeout(() => {
          this.$router.back();
        }, 4000);
      } else {
        this.$message({
          message: '请确认id是否正确',
          type: 'warning',
          duration: 1000,
          offset: 150,
        });
      }
      this.$message({
        type: 'success',
        message: '删除成功,将返回上一页!',
        duration: 1000,
        offset: 150,
      });
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除',
        duration: 1000,
        offset: 150,
      });
    });


  }
}
